import React, { useEffect, useRef, useState } from "react";
import QRCode from "qrcode.react";
import { ReactComponent as alipaySvg } from "@/assets/icons/alipay.svg";
import { ReactComponent as wechatSvg } from "@/assets/icons/wechat.svg";
import { getOrderMemberDetail } from "@/api/order";
import { toYuan } from "@/utils/money";
import { generateUUID } from "@/utils/random";

import "./qrcode-card.scss";
import config from "@/config";
import { genBlock } from "@/utils/bem";
import { Box, Flex, chakra, Text } from "@chakra-ui/react";
import Icon from "@/components/Icon";
import { getShortUrl } from "@/api/url";
const { payPageURL } = config;
interface QRcodeCardProps {
  productId?: number | null;
  amount?: number;
  amountDesc?: string;
  // 自定义购买画力星数量的时候才传
  heartCoin?: number;
  discount?: number;
  onSuccess?: () => void;
  isYuan?: boolean;
  redirectUri?: string;
}

const block = genBlock("c-qrcode-card");
const QRcodeCard: React.FC<QRcodeCardProps> = ({
  productId,
  amount = 0,
  amountDesc = "",
  heartCoin = 100,
  onSuccess,
  isYuan = false,
  redirectUri = "/",
}) => {
  const [payUrl, setPayUrl] = useState("");
  const timer = useRef<any>();
  const queryCode = useRef("");
  const payUrlTimerRef = useRef<any>();

  // 获取支付二维码
  useEffect(() => {
    clearInterval(payUrlTimerRef.current);
    getPayQRCode();
    payUrlTimerRef.current = setInterval(() => {
      getPayQRCode();
    }, 15000);

    return () => {
      clearInterval(timer.current);
      clearInterval(payUrlTimerRef.current);
    };
  }, [productId, heartCoin]);

  function getPayQRCode() {
    if (!productId) return;
    console.log("process.env.REACT_ENV: ", process.env);
    const uuid = generateUUID();
    queryCode.current = uuid;
    const token = localStorage.getItem("token");
    const url = `${payPageURL}/pay-h5-mobile?env=${
      process.env.REACT_APP_ENV
    }&queryCode=${uuid}&token=${token}&productId=${productId}${
      productId === 10000 ? "&heart_coin=" + heartCoin : ""
    }&source=creator&redirect_uri=${encodeURIComponent(redirectUri)}&time=${new Date().getTime()}`;
    console.log("url: ", url);
    getShortUrl(url)
      .then((res) => res)
      .then((res) => {
        if (res?.data?.url) {
          setPayUrl(`${config.creatorUrl}/short?s=${res.data.url}`);
        } else {
          setPayUrl(url);
        }
      });
    checkLoop();
  }

  // 循环支付检查
  const checkLoop = () => {
    clearInterval(timer.current);
    timer.current = setInterval(getOrderStatus, 2000);
  };

  // 获取订单状态
  const getOrderStatus = () => {
    getOrderMemberDetail({ query_code: queryCode.current }).then((res: any) => {
      if (res.code == 0) {
        const { pay_status } = res.data || {};
        if (pay_status === 2) {
          clearInterval(timer.current);
          onSuccess?.();
        }
      }
    });
  };

  return (
    <Box className={block()}>
      <div className={block({ e: "qrCode" })}>
        {payUrl ? <QRCode level="L" size={112} value={payUrl} /> : null}
      </div>
      <div className={block({ e: "right" })}>
        <Flex className={block({ e: "price" })} align="baseline" flexWrap="wrap">
          <chakra.span fontSize="14px">扫码支付：</chakra.span>
          <chakra.span fontSize="20px" color="#EABB6A" pos="relative">
            ￥
          </chakra.span>
          <chakra.strong
            fontSize="40px"
            lineHeight="56px"
            fontWeight={600}
            color="#EABB6A"
            pos="relative"
          >
            {isYuan ? amount : toYuan(amount)}
          </chakra.strong>
          <chakra.span fontSize="12px" color="#EABB6A" pos="relative">
            {amountDesc}
          </chakra.span>
        </Flex>
        <Flex className={block({ e: "method" })} gap="8px">
          <Icon svg={alipaySvg} squared={false} />
          <Icon svg={wechatSvg} squared={false} />
          使用支付宝/微信扫码支付
        </Flex>
        <Text className={block({ e: "tips" })}>支付即视为您已阅读并同意左侧的付费说明</Text>
      </div>
    </Box>
  );
};

export default QRcodeCard;
